/* eslint-disable */
import urlConfig from '../config'
;(function () {
  if (process.server) { return }

  // 用于生成uuid
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  function guid() {
    return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4())
  }
  function setXY(x, y) {
    // console.log(document.body.clientHeight,'document.body.clientWidth')
    const lo = Math.round(Math.round(100 * x / document.body.clientWidth) / 5) * 5 / 100 + '*' + Math.round((Math.round(1000 * y / document.body.clientHeight) / 2)) * 2 / 1000

    // console.log(lo,'lo')

    return lo
  }

  //  定义一个对象万能方法集合器
  const
        zmMethod = {}
  const
        zmCookie = null

  //  cookie处理

  zmMethod.cookie = {}

  /*
      d.H 存放时间
      d.domain 存哪里
      ...
  */
  zmMethod.cookie.set = function (a, b, d) {
    let f

    d.H && (f = new Date(), f.setTime(f.getTime() + d.H))
    document.cookie = a + '=' + b + (d.domain ? '; domain=' + d.domain : '') + (d.path ? '; path=' + d.path : '') + (f ? '; expires=' + f.toGMTString() : ';expire=Thu, 18 Dec 2013') + (d.hb ? '; secure' : '')
  }
  zmMethod.cookie.get = function (a) {
    return (a = RegExp('(^| )' + a + '=([^;]*)(;|$)').exec(document.cookie)) ? a[2] : zmCookie
  }

  //  原生方法封装
  zmMethod.Utils = {}
  zmMethod.Utils.getById = function (a) {
    return document.getElementById(a)
  }
  zmMethod.Utils.getDomain = function () {
    return document.domain
  }
  zmMethod.Utils.getUrl = function () {
    return document.URL
  }
  zmMethod.Utils.getTitle = function () {
    return document.title
  }
  zmMethod.Utils.getUrl = function () {
    const sUrl = document.URL
    const sNoHttpUrl = sUrl ? sUrl.split('://')[1] : ''

    return sNoHttpUrl ? sNoHttpUrl.split('?')[0] : sNoHttpUrl
  }
  zmMethod.Utils.getPreUrl = function () {
    return document.referrer
  }

  // 分辨率
  zmMethod.Utils.getRp = function () {
    return (window.screen.height + '*' + window.screen.width)
  }

  // 颜色深度
  zmMethod.Utils.getColorDepth = function () {
    return window.screen.colorDepth
  }

  // 获取url中的参数
  zmMethod.Utils.getQueryString = function (name) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i') // 匹配目标参数
    const result = window.location.search.substr(1).match(reg) // 对querystring匹配目标参数

    if (result != null) {
      return decodeURIComponent(result[2])
    } else {
      return null
    }
  }
  zmMethod.Utils.bindEvent = function (a, b, d) {
    a.attachEvent ? a.attachEvent('on' + b, function (b) {
      d.call(a, b)
    }) : a.addEventListener && a.addEventListener(b, d)
  }
  zmMethod.Utils.removeEvent = function (a, b, d) {
    a.detachEvent ? a.detachEvent('on' + b, function (b) {
      d.call(a, b)
    }) : a.removeEventListener && a.removeEventListener(b, d)
  }
  zmMethod.Utils.parse = function () {
    return (new Function('return (" + source + ")'))()
  }
  zmMethod.Utils.stringify = function () {
    function a(a) {
      /["\\\x00-\x1f]/.test(a) && (a = a.replace(/["\\\x00-\x1f]/g, function (a) {
        let b = d[a]

        if (b) { return b }
        b = a.charCodeAt()
        return '\\u00' + Math.floor(b / 16).toString(16) + (b % 16).toString(16)
      }))
      return '"' + a + '"'
    }
    function b(a) {
      return a < 10 ? '0' + a : a
    }
    var d = {
      '\b': '\\b',
      '\t': '\\t',
      '\n': '\\n',
      '\f': '\\f',
      '\r': '\\r',
      '"': '\\"',
      '\\': '\\\\'
    }

    return function (d) {
      switch (typeof d) {
        case 'undefined':
          return 'undefined'
        case 'number':
          return isFinite(d) ? String(d) : 'null'
        case 'string':
          return a(d)
        case 'boolean':
          return String(d)
        default:
          if (d === t) { return 'null' }
          if (d instanceof Array) {
            var g = ['['], n = d.length, l, p, e

            for (p = 0; p < n; p++) {
              switch (e = d[p],
              typeof e) {
                case 'undefined':
                case 'function':
                case 'unknown':
                  break
                default:
                  l && g.push(','),
                  g.push(mt.l.stringify(e)),
                  l = 1
              }
            }
            g.push(']')
            return g.join('')
          }
          if (d instanceof Date) { return '"' + d.getFullYear() + '-' + b(d.getMonth() + 1) + '-' + b(d.getDate()) + 'T' + b(d.getHours()) + ':' + b(d.getMinutes()) + ':' + b(d.getSeconds()) + '"' }
          l = ['{']
          p = mt.l.stringify
          for (n in d) {
            if (Object.prototype.hasOwnProperty.call(d, n)) {
              switch (e = d[n],
              typeof e) {
                case 'undefined':
                case 'unknown':
                case 'function':
                  break
                default:
                  g && l.push(','),
                  g = 1,
                  l.push(p(n) + ':' + p(e))
              }
            }
          }
          l.push('}')
          return l.join('')
      }
    }
  }
  function isTj(arr) {
    for (let i = 0; i < arr.length; i++) {
      if (window.location.pathname === arr[i]) {
        return true
      }
    }
    return false
  }

  // console.log(document.body.clientWidth,'clientWidth')
  const arrTj = ['/', '/lp/sem']
  let st = 0
  let seCookie = zmMethod.cookie.get('zmTongJi_session')
  let cookieInfo = seCookie && seCookie.split('entertime=')
  const domain = zmMethod.Utils.getDomain()

  zmMethod.Utils.sendMessage = function (options) {
    if (!options) { return }

    // console.log(urlConfig)
    const baseUrl = urlConfig.marketURL + '/z.gif?'

    const ur = zmMethod.Utils.getUrl()
    const co = zmMethod.Utils.getQueryString('channel_code') || ''
    const ke = zmMethod.Utils.getQueryString('channel_keyword') || ''
    const ti = zmMethod.Utils.getTitle()
    const re = zmMethod.Utils.getPreUrl()
    const sc = zmMethod.Utils.getRp()
    const cd = zmMethod.Utils.getColorDepth()

    const ev = options.ev || ''
    const ck = options.ck || ''
    const li = options.li || ''
    const lt = options.lt || ''
    const lo = options.lo || ''
    const sk = options.sk || ''

    if (!isTj(arrTj)) {
      zmMethod.Utils.removeEvent(window, 'click')
      return
    }
    const oImg = new Image(1, 1)

    oImg.src = baseUrl + 'co=' + co + '&ke=' + ke + '&ev=' + ev + '&st=' + st + '&do=' + domain + '&ur=' + ur + '&ti=' + ti + '&re=' + re + '&sc=' + sc + '&cd=' + cd + '&ck=' + ck + '&li=' + li + '&lt=' + lt + '&lo=' + lo + '&sk=' + sk

    // console.log(ur,'ur')
    // console.log(re,'re')
    console.log(oImg.src)
  }

  //  页面加载
  window.onload = function () {
    //  访客会话唯一标识
    if (!zmMethod.cookie.get('zmTongJi_session')) {
      const sessionKey = guid() + 'entertime=' + new Date().getTime()

      zmMethod.cookie.set('zmTongJi_session', sessionKey, { domain: domain })
    }
    seCookie = zmMethod.cookie.get('zmTongJi_session')
    cookieInfo = seCookie && seCookie.split('entertime=')

    //  访客唯一标识
    if (!zmMethod.cookie.get('zmTongJi')) {
      const key = 'zmtj-' + guid()

      zmMethod.cookie.set('zmTongJi', key, {
        domain: domain, H: 9000000000000
      })
      zmMethod.Utils.sendMessage({
        ev: 1, sk: cookieInfo[0], ck: key.split('zmtj-')[1]
      })
    } else {
      zmMethod.Utils.sendMessage({
        ev: 1, sk: cookieInfo[0], ck: zmMethod.cookie.get('zmTongJi').split('zmtj-')[1]
      })
    }

    // console.log(zmMethod.cookie.get('zmTongJi_session'))
  }
  window.onbeforeunload = function (e) {
    st = cookieInfo[1] ? (new Date().getTime() - cookieInfo[1]) : 0
    const uid = cookieInfo[0] + 'entertime=' + new Date().getTime()

    zmMethod.cookie.set('zmTongJi_session', uid, { domain: domain })
    zmMethod.Utils.sendMessage({
      ev: 2, sk: cookieInfo[0]
    })
  }

  //  监听全局点击事件
  //  只监听首页
  // console.log(isTj(arrTj))
  // window.onclick = function() {
  //     console.log('wdsd')
  // }
  // var oApp = zmMethod.Utils.getById
  // if(!isTj(arrTj)){
  // zmMethod.Utils.bindEvent(window,'click',function(e){
  //     var e = e||window.event
  //     var options = {
  //         ev: 3,lt:0,lo:setXY(e.pageX,e.pageY),
  //         sk:cookieInfo[0]
  //     }
  //     zmMethod.Utils.sendMessage(options)
  //     // console.log(e,'ev')
  // })
  // }else{
  //     zmMethod.Utils.removeEvent(window,'click')
  // }
})()
